export let $alert;
export let $modal;

export function setupAngularImports($i): void {
    $alert = $i.get('$alert');
    $modal = $i.get('$modal');
}
